import { render, staticRenderFns } from "./KemaskiniMaklPemohonFasi.vue?vue&type=template&id=0212dda2&scoped=true&"
import script from "./KemaskiniMaklPemohonFasi.vue?vue&type=script&lang=js&"
export * from "./KemaskiniMaklPemohonFasi.vue?vue&type=script&lang=js&"
import style0 from "./KemaskiniMaklPemohonFasi.vue?vue&type=style&index=0&id=0212dda2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0212dda2",
  null
  
)

export default component.exports